import React, { useState } from 'react';

import { Container, UnitContainer, UnitText } from './Toggle.styles';

export interface ToggleProps {
  options: string[];
  onSelectSwitch: (value: string) => void;
  value: string;
  limitWidth?: boolean;
}

const Toggle = ({ options, onSelectSwitch, value, limitWidth = true }: ToggleProps) => {
  const [selectedValue, setSelectedValue] = useState(value || options[0]);

  const handleChangeValue = (option: string) => {
    setSelectedValue(option);
    onSelectSwitch(option);
  };

  return (
    <Container>
      {options.map((option, index) => (
        <UnitContainer
          id={`unit-${option}`}
          key={index}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            handleChangeValue(option);
          }}
          $isActive={selectedValue === option}
          $isLast={options.length - 1 === index}
          $isOnlyOneOption={options.length === 1}
          $limitWidth={limitWidth}
        >
          <UnitText $isActive={selectedValue === option}>{option}</UnitText>
        </UnitContainer>
      ))}
    </Container>
  );
};

export default Toggle;
